export default class ReportCodeFiltersViewModel {
    isActive: boolean = false;
    reportCode1: ReportCodeFilter = new ReportCodeFilter();
    reportCode2: ReportCodeFilter = new ReportCodeFilter();
    reportCode3: ReportCodeFilter = new ReportCodeFilter();
    reportCode5: ReportCodeFilter = new ReportCodeFilter();
}

export class ReportCodeFilter {
    values: string[] = [];
    excluded: boolean = false;
}